module.exports = __webpack_public_path__ + "static/media/Bath8.60768c82.jpg";